import { render, staticRenderFns } from "./membershipLayout.vue?vue&type=template&id=0c704ed9"
import script from "./membershipLayout.vue?vue&type=script&lang=js"
export * from "./membershipLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports